<script setup>
import { ComboboxInput, useForwardPropsEmits } from "reka-ui";
import { reactiveOmit } from "@vueuse/core";
import { cn } from "@/shared/lib/utils";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
  type: { type: String, default: undefined },
  disabled: { type: Boolean, default: undefined },
  autoFocus: { type: Boolean, default: undefined },
});

const emits = defineEmits(["update:modelValue"]);

const delegatedProps = reactiveOmit(props, "class");
const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <ComboboxInput
    data-slot="combobox-input"
    :class="
      cn(
        'placeholder:text-muted-foreground placeholder:text-xs flex h-10 w-full bg-transparent text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        props.class
      )
    "
    v-bind="{ ...$attrs, ...forwarded }"
  >
    <slot />
  </ComboboxInput>
</template>
